import { Footer } from '@/components/shared/Footer';
import { Header } from '@/components/shared/Header';
import { Outlet } from 'react-router-dom';

export const LanderContainer = () => {
  return (
    <div>
      <Header>
        <div className="max-w-3xl mx-auto p-4">
          <Outlet />
        </div>
      </Header>
      <Footer />
    </div>
  );
};
